import { BrowserWindowContext } from '../components/BrowserWindowContext';
import { jsx as _jsx } from "react/jsx-runtime";
export function withBrowserSizeContext(Component) {
  /* eslint-disable-next-line react/display-name */
  return props => {
    return /*#__PURE__*/_jsx(BrowserWindowContext.Consumer, {
      children: ({
        browserWindowHeight,
        browserWindowWidth
      }) => {
        return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
          browserWindowHeight: browserWindowHeight,
          browserWindowWidth: browserWindowWidth
        }));
      }
    });
  };
}